/**
 * How a comment opens a line, wherever a line stands for it (P-26; Jason, 2026-10-24: "a truncated beginning of the
 * comment"): the timeline's line for a comment on anything, and a resolved comment folded in place on its file
 * (design study 29, fold A; Jason, 2026-10-28: "maybe it just folds the comment up with a single line of the text ending
 * in ... i dont want to lose the comments"). One rule, so the two never cut it differently; opened, it reads whole.
 */

/** How much of a comment a line opens with. */
export const OPENING = 60;

/** The start of someone's words for a line: on one line, cut at a whole word with an ellipsis when longer than `max`. */
export function opening(text: string, max = OPENING): string {
  const flat = text.replace(/\s+/g, ' ').trim();
  if (flat.length <= max) return flat;
  const cut = flat.slice(0, max + 1);
  const space = cut.lastIndexOf(' ');
  return `${(space > max / 2 ? cut.slice(0, space) : flat.slice(0, max)).replace(/[\s,;:.!?–—-]+$/u, '')}…`;
}
